export const getState = function (key) {
    //using sessionStorage instead of localStorage
    return JSON.parse(window.sessionStorage.getItem(key));
};

export const setState = function (key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state));
};

export const removeState = (key) => {
    window.sessionStorage.removeItem(key);
  };

  export default { getState, setState, removeState };